/* Terashack: add-to-cart for product cards ("Add +") and the product page form.
   Posts to /cart/add, then refreshes and opens the cart drawer. Without JS the
   forms still post normally and Shopify sends the buyer to the cart. */
(function () {
  function sectionsToRender(drawer) {
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return [];
    return drawer.getSectionsToRender().map(function (s) { return s.id; });
  }

  function showError(form, message) {
    var box = form.querySelector('[data-ts-error]') || document.querySelector('[data-ts-error="' + form.id + '"]');
    if (box) { box.textContent = message || ''; return; }
    if (message) window.alert(message);
  }

  function submit(form, submitter) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.fetch || !window.FormData) return false;

    var buttons = [submitter].concat(Array.prototype.slice.call(document.querySelectorAll('[form="' + form.id + '"]')));
    buttons.forEach(function (b) { if (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; } });
    showError(form, '');

    var body = new FormData(form);
    var sections = sectionsToRender(drawer);
    if (sections.length) {
      body.append('sections', sections.join(','));
      body.append('sections_url', window.location.pathname);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status) { showError(form, json.description || json.message); return; }
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(submitter || document.activeElement);
        drawer.renderContents(json);
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        buttons.forEach(function (b) { if (b) { b.removeAttribute('aria-busy'); b.disabled = false; } });
      });
    return true;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-ts-add]')) return;
    if (submit(form, e.submitter || form.querySelector('[type="submit"]'))) e.preventDefault();
  });
})();
